import jsonp from 'jsonp';

import config from '../config';
import { CardLockStatus } from '../constants/AppConstants';


const CardLockService = {

    getToken (cardNumber, securityCode) {
        return new Promise((resolve, reject) => {
            const endpoint = config.get('cardLockUrl')
                .replace('{cardNumber}', cardNumber)
                .replace('{securityCode}', securityCode)
                .replace('{publishableId}', config.get('cardLockId'));

            jsonp(endpoint, (error, response) => {
                if (error) {
                    reject(error);
                } else if (response.status !== CardLockStatus.SUCCESS) {
                    reject(new Error(response.status));
                } else {
                    resolve(response.token);
                }
            });
        });
    }

};


export default CardLockService;



// WEBPACK FOOTER //
// ./src/services/CardLockService.js